var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cuentas_Por_pagar"},[_c('navigation'),_c('cuentasPorpagar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }